import { isoDay, toInstant, toWall } from './create-post/form';

/** `datetime-local` works in the viewer's local time, without a zone. */
export function toLocalInput(date: Date): string {
  const local = new Date(date.getTime() - date.getTimezoneOffset() * 60_000);
  return local.toISOString().slice(0, 16);
}

/** A `datetime-local` value on `timeZone`'s clock, or the viewer's without one. */
export function toZoneInput(date: Date, timeZone?: string): string {
  if (!timeZone) return toLocalInput(date);
  const wall = toWall(date, timeZone);
  return `${isoDay(wall.date)}T${wall.time}`;
}

/** The instant a `datetime-local` value means on `timeZone`'s clock (or the viewer's). */
export function fromZoneInput(value: string, timeZone?: string): Date {
  if (!timeZone) return new Date(value);
  const [day, time] = value.split('T') as [string, string];
  const [year, month, date] = day.split('-').map(Number) as [number, number, number];
  return toInstant(new Date(year, month - 1, date), time, timeZone);
}
